export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43')
];

export const server_loads = [0,2];

export const dictionary = {
		"/": [3],
		"/about": [~4],
		"/blog/posts": [5],
		"/blog/posts/[idPost]": [~6],
		"/bookYourLaunch": [~7],
		"/company/facility": [8],
		"/company/history": [9],
		"/company/newsRoom": [10],
		"/contactUs/bookYourLaunch": [12],
		"/contactUs/reachOut": [13],
		"/contact": [~11],
		"/glossary/[name]": [14],
		"/launchArchive": [~16],
		"/launchSchedule": [~17],
		"/launchSchedule/o/[operatorId]": [~18],
		"/launchSchedule/s/[siteId]": [~19],
		"/launchSchedule/v/[vehicleId]": [~20],
		"/launch/[idLaunch]": [~15],
		"/login": [21],
		"/news": [~22],
		"/privacyPolicy": [23],
		"/report/operators": [~24],
		"/report/operators/[idOperator]": [~25],
		"/report/sites": [~26],
		"/services/customsClearance": [27],
		"/services/insurance": [28],
		"/services/launchCapacity": [29],
		"/services/launchMissionManagement": [30],
		"/services/satellitePreparation": [31],
		"/services/shipment": [32],
		"/services/storage": [33],
		"/sitemap": [34],
		"/tools/blog/posts": [35],
		"/tools/blog/posts/[idPost]": [36],
		"/tools/launchArchive": [38],
		"/tools/launchSchedule": [39],
		"/tools/launch/[idLaunch]": [37],
		"/tools/operators": [40],
		"/tools/operators/[idOperator]": [41],
		"/tools/payloads": [~42,[2]],
		"/tools/sites": [43]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';